import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./state-slices/auth";
import apiTriggerSlice from "./state-slices/apiTrigger";
import eventDetailsSlice from "./state-slices/eventDetails";
import uploadPhotosSlice from "./state-slices/photosUpload";
import profileDetailsSlice from "./state-slices/profileDetails";
import plansSlice from "./state-slices/plans";
import roleSlice from "./state-slices/userRole";
import storageDetailsSlice from "./state-slices/storageDetails";
import userRegistrationSlice from "./state-slices/userRegistration";
import modalSlice from "./state-slices/modalControl";
import fileDetailsSidebarSlice from "./state-slices/fileDetailsSidebar";

const globalStore = configureStore({
  reducer: {
    auth: authSlice.reducer,
    apiTrigger: apiTriggerSlice.reducer,
    eventDetails: eventDetailsSlice.reducer,
    uploadPhotos: uploadPhotosSlice.reducer,
    profileDetails: profileDetailsSlice.reducer,
    plans: plansSlice.reducer,
    role: roleSlice.reducer,
    storageDetails: storageDetailsSlice.reducer,
    userRegistration: userRegistrationSlice.reducer,
    modal: modalSlice.reducer,
    fileDetailsSideBar: fileDetailsSidebarSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default globalStore;
